import { TutorialStep } from "..";

export const CreateDatasetBtnSteps: TutorialStep[] = [
  {
    target: "#create-dataset-btn",
    content: "새로 만들기: 특정 이미지들을 선택하여 새로운 데이터셋을 생성합니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#create-dataset-btn",
    content: "버튼을 클릭하여 데이터셋을 새롭게 만들어보세요",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
